import React from 'react'

import { TextArea } from 'components/ds'

type Props = React.ComponentProps<typeof TextArea> & {
  grow?: boolean
  containerStyle?: React.CSSProperties
  textAreaStyle?: React.CSSProperties
}

export const getTextAreaProps = (props: Props) => {
  return {
    ...props,
    grow: false,
    containerStyle: {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      fontFamily: 'inherit',
      overflowY: 'hidden',
      fontSize: 'var(--font-size-2)',
      lineHeight: 'var(--line-height-2)',
      visibility: 'hidden',
      height: '100%',
      maxHeight: '60vh',
      minHeight: '200px',
    } as React.CSSProperties,
    textAreaStyle: { overflowY: 'auto' } as React.CSSProperties,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    } as React.CSSProperties,
  }
}
